import React from 'react';

import { Container } from './styles';

function Footer() {
    return (
        <Container>
            <span>
                Copyright <strong>Acme</strong> &copy; 2020
            </span>
        </Container>
    );
}

export default Footer;
